import api from '@pray/shared/utils/api';

import { toArticleUpdateError } from './articleUpdateError';
import type { ArticleHtmlBlock } from './types';

/* eslint-disable camelcase */
type SolomonInsightsPayload = {
  summary: string;
  related_verses: string[];
  reflection_prompt: string;
  generated_at: string;
};

type UpdateArticleData = {
  title?: string;
  slug?: string;
  cover_image_url?: string | null;
  content?: ArticleHtmlBlock[];
  excerpt?: string | null;
  category_id?: string | null;
  tags?: string[];
  seo_title?: string | null;
  seo_description?: string | null;
  solomon_insights?: SolomonInsightsPayload | null;
  reading_time?: number | null;
  author_name?: string | null;
  author_image_url?: string | null;
  content_id?: string | null;
};
/* eslint-enable camelcase */

type UpdateArticleProps = {
  artistId: string;
  articleId: string;
  title?: string;
  slug?: string;
  coverImageUrl?: string | null;
  content?: ArticleHtmlBlock[];
  excerpt?: string | null;
  categoryId?: string | null;
  tags?: string[];
  seoTitle?: string | null;
  seoDescription?: string | null;
  solomonInsights?: SolomonInsightsPayload | null;
  readingTime?: number | null;
  authorName?: string | null;
  authorImageUrl?: string | null;
  contentId?: string | null;
};

export async function updateArticle({
  artistId,
  articleId,
  title,
  slug,
  coverImageUrl,
  content,
  excerpt,
  categoryId,
  tags,
  seoTitle,
  seoDescription,
  solomonInsights,
  readingTime,
  authorName,
  authorImageUrl,
  contentId,
}: UpdateArticleProps) {
  if (!artistId) throw Error('Artist ID is required');
  if (!articleId) throw Error('Article ID is required');

  const url = `/web/studio/artists/${artistId}/articles/${articleId}`;

  const data: UpdateArticleData = {};

  if (title !== undefined) data.title = title;
  if (slug !== undefined) data.slug = slug;
  if (coverImageUrl !== undefined) data.cover_image_url = coverImageUrl;
  if (content !== undefined) data.content = content;
  if (excerpt !== undefined) data.excerpt = excerpt;
  if (categoryId !== undefined) data.category_id = categoryId;
  if (tags !== undefined) data.tags = tags;
  if (seoTitle !== undefined) data.seo_title = seoTitle;
  if (seoDescription !== undefined) data.seo_description = seoDescription;
  if (solomonInsights !== undefined) data.solomon_insights = solomonInsights;
  if (readingTime !== undefined) data.reading_time = readingTime;
  if (authorName !== undefined) data.author_name = authorName;
  if (authorImageUrl !== undefined) data.author_image_url = authorImageUrl;
  if (contentId !== undefined) data.content_id = contentId;

  try {
    await api.executePutRequest(url, data);
  } catch (error: unknown) {
    const response = (error as { response?: { status: number; data?: unknown } } | null)?.response;
    throw response ? toArticleUpdateError(response.status, response.data) : error;
  }
}
